"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.modifyMask = exports.buildDate = exports.formatToMask = exports.isLowAlpha = void 0;
var parseISO_1 = __importDefault(require("date-fns/parseISO"));
var isLowAlpha = function (char) {
    var code = char.charCodeAt(0);
    return (code > 96 && code < 123); // [a-z]
};
exports.isLowAlpha = isLowAlpha;
var formatToMask = function (format) { return format.split("").map(function (char) { return exports.isLowAlpha(char) ? "9" : char; }).join(""); };
exports.formatToMask = formatToMask;
/**
 * Build Date object from date string and format
 * @param input - Date string ex(12/02/2010)
 * @param format - Format of provided date string ex(dd/mm/yyyy
 */
var buildDate = function (input, format) {
    var dateStruct = format.split("").reduce(function (struct, key, i) {
        if (key in struct) {
            struct[key] += input[i];
        }
        return struct;
    }, { d: "", m: "", y: "" });
    return parseISO_1.default(dateStruct.y + "-" + dateStruct.m + "-" + dateStruct.d); // ISO 8601 format;
};
exports.buildDate = buildDate;
var modifyMask = function (mask, modifier) { return (modifier ? mask.split("").map(function (char) { return exports.isLowAlpha(char) ? modifier(char) : char; }).join("") : mask); };
exports.modifyMask = modifyMask;
